import { getUserLanguage } from '@/utils/langs';

export const Slide = ({ slideName }: { slideName: string }) => {
  const lang = getUserLanguage();

  return (
    <div className="mockup-phone h-[calc(100vh-130px)] max-h-[800px] w-full max-w-[400px]">
      <div className="mockup-phone-display max-h-[773px] w-full">
        <div className="bg-card">
          <img
            className="w-full"
            src={`/images/auth/${lang === 'ru' ? 'ru' : 'en'}/${slideName}`}
            alt="phone"
          />
        </div>
      </div>
    </div>
  );
};
